import { useUserCanAccess } from '@/hooks/auth';
import { Playlist } from '@/prisma/utils/playlist';
import { Button, HStack } from '@chakra-ui/react';

type PlaylistControlsProps = {
	playlist: Playlist;
	onAddMediaClick: () => void;
	onEditClick: () => void;
	onDeleteClick: () => void;
};

const PlaylistControls: React.FC<PlaylistControlsProps> = ({
	playlist,
	onAddMediaClick,
	onEditClick,
	onDeleteClick,
}) => {
	const hasAccess = useUserCanAccess(playlist.owner);

	return (
		<>
			<HStack as="nav">
				<Button
					disabled={!hasAccess}
					onClick={onAddMediaClick}
				>
					Add Media
				</Button>
				<Button
					disabled={!hasAccess}
					onClick={onEditClick}
				>
					Edit
				</Button>
				<Button
					disabled={!hasAccess}
					onClick={onDeleteClick}
				>
					Delete
				</Button>
			</HStack>
		</>
	);
};

export default PlaylistControls;
